// components/Footer.js
import { Container } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="bg-secondary text-dark text-center py-3 mt-auto">
      <Container>
        <p className="mb-0 small">© 2025 - OpenDataKBB Semua Hak Dilindungi.</p>
      </Container>
    </footer>
  );
}

export default Footer;
